import { Locale } from '../../../../core/i18n/Locale';
import { getSiteByLocale } from '../../../../core/Site/Site';
import { generateUrl, RouteName, RouteParams } from '../../../../shared/utilities/routing/routing';

const { PYRITE_API_URL } = process.env;

type PyriteRequest = {
    url: string;
    forwardedHost?: string;
};

/**
 * On the server, Pyrite is reached service-to-service via PYRITE_API_URL, mirroring the
 * other backend APIs (MEMBER_API_URL, etc.). Pyrite routes by host, so the market host is
 * forwarded through X-Forwarded-Host (the `Host` header is dropped by fetch). On the client,
 * and when PYRITE_API_URL is unset, the public URL is used so the request transits the gateway.
 */
export function buildPyriteRequest(
    routeName: RouteName,
    locale: Locale,
    params: RouteParams = {},
): PyriteRequest {
    if (typeof window === 'undefined' && PYRITE_API_URL) {
        return {
            url: `${PYRITE_API_URL}${generateUrl(routeName, locale, params)}`,
            forwardedHost: getSiteByLocale(locale).host,
        };
    }

    return { url: generateUrl(routeName, locale, params, true) };
}
